import * as React from "react";
import {useState, useEffect} from 'react';
import PageContainer from "../core/PageContainer";
import ModernCard from "../core/ModernCard";
import Breadcrumbs from "../core/Breadcrumbs";
import { jfetch, toast } from "../../utils";
import Button from "../core/Button";
import { useHistory } from "react-router-dom";
import IconPicker from "../core/IconPicker"
import Select from 'react-select-new';

interface IProps {
  userContext:any;
}

function QuoteCalculatorNew(props:IProps){
  const [name, setName] = useState('')
  const [icon, setIcon] = useState('')
  const [services, setServices] = useState([])
  const [myServices, setMyServices] = useState([])
  const [products, setProducts] = useState([])
  const [myProducts, setMyProducts] = useState([])
  const [charges, setCharges] = useState([])
  const [myCharges, setMyCharges] = useState([])
  const [projectServices, setProjectServices] = useState([])
  const [myProjectServices, setMyProjectServices] = useState([])  
  let history = useHistory()
 const event = new Event('quote_change');

  useEffect(() => {
    jfetch
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/base_options`)
    .then((resp) => {
      setServices(resp.all_services)
      setProducts(resp.all_products)
      setCharges(resp.all_charges)
      setProjectServices(resp.all_project_services)
    })  
  }, [])

  useEffect(() => {
    window.document.dispatchEvent(event);
  }, [])

  return (
    <PageContainer>   
      <Breadcrumbs
        crumbs={[
          {
            label: "Pricing Quote Dashboard",
            route: "/quote_calculator",
            routerLink: true,
          },
          { label: "New Quote Calculator" },
        ]}
      />
      <div className="quote-calc-new-root">
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta='left'>
              <div className="row"> 
                <div className="col-lg-6">
                  <div className="form-group">
                    <h3>Calculator Name</h3>
                    <input 
                      type="text" 
                      className="form-control"
                      onChange={(e) => setName(e.target.value)} 
                    />
                  </div>
                  <IconPicker icon={icon} updateIcon={(i) => setIcon(i)} /> 
                </div>
              </div>             
            </ModernCard>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta='left'>
              <h3>Monthly Support Services</h3>
              <Select options={services} value={myServices} isMulti className="basic-multi-select" onChange={(selected) => setMyServices(selected)} />
            </ModernCard>
          </div>
        </div> 
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta='left'>
              <h3>Monthly Products</h3>
              <Select options={products} value={myProducts} isMulti className="basic-multi-select" onChange={(selected) => setMyProducts(selected)} />
            </ModernCard>
          </div>
        </div> 
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta='left'>
              <h3>One-Time Purchase/HaaS Product</h3>
              <Select options={charges} value={myCharges} isMulti className="basic-multi-select" onChange={(selected) => setMyCharges(selected)} />
            </ModernCard>
          </div>
        </div> 
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta='left'>
              <h3>Project Labor</h3>
              <Select options={projectServices} value={myProjectServices} isMulti className="basic-multi-select" onChange={(selected) => setMyProjectServices(selected)} />
            </ModernCard>
          </div>
        </div>         
        <div className="row" style={{paddingTop:'15px', paddingBottom:'15px'}}>
          <div className="col-lg-12 text-right">
            <Button 
              color="primary"
              onClick={() => {
                jfetch.post(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator`, {
                  name: name,
                  icon: icon,
                  user_id: props.userContext.user.id,
                  organization_id: props.userContext.org.id,
                  services: myServices,
                  products: myProducts,
                  charges: myCharges,
                  project_services: myProjectServices
                })
                .then((resp) => {
                  history.push('/quote_calculator')
                  toast.success('Calculator Was Created');
                })
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </div>          
    </PageContainer>
  )
}

export default QuoteCalculatorNew;


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuoteCalculatorNew.tsx